import { useOwnershipLabels } from "../../OwnershipLabels";
import React from "react";

const ENTITY_TYPES = {
  PIC: "private investment company",
  "Domiciliary Company (PIC)": "private investment company",
  HoldingPassive: "passive holding company",
  "Holding (Passive)": "passive holding company",
  HoldingActive: "active holding company",
  "Holding (Active)": "active holding company",
  "Non Quoted Operational Company": "operating company",
  "Operating Company": "operating company",
  "Quoted Company": "listed company",
  Trust: "trust",
  Foundation: "foundation",
  Individual: "individual",
};

function reviewMessage(entry, nodes) {
  const node = nodes.find(candidate => String(candidate?.ID) === String(entry.nodeId));
  const name = String(node?.name || "").trim();
  const type = ENTITY_TYPES[node?.type];
  const label = name && name !== String(node?.ID)
    ? `${name}${type ? ` (${type})` : ""}`
    : type ? `An unnamed ${type}` : "An entry in the ownership structure";

  switch (entry.code) {
    case "SPECIAL_RULES_REQUIRED":
      return `${label}: Automatic identification is not available for this entity type. Review who ultimately owns or controls this entity.`;
    case "OWNERSHIP_INCOMPLETE":
      return `${label}: Shareholder details are missing. Add its shareholders to continue identifying beneficial owners.`;
    case "MISSING_PCT":
      return `${label}: The ownership percentage is missing or invalid. Check and complete the ownership details, then run identification again.`;
    case "MANAGING_DIRECTOR_REQUIRED":
      return `${label}: No person holds 25% or more or controls it by other means. Name its highest managing director on Form K.`;
    case "NOMINEE_HOLDER":
      return `${label}: This holder is a nominee. Add the person it acts for, who must be named instead.`;
    case "MISSING_SETTLOR":
    case "MISSING_FOUNDER":
      return `${label}: The ${entry.code === "MISSING_SETTLOR" ? "settlor" : "founder"} is missing. Add it to complete Form ${entry.code === "MISSING_SETTLOR" ? "T" : "S"}.`;
    case "MISSING_BENEFICIARIES":
      return `${label}: No beneficiaries or class of beneficiaries recorded. Add them to complete the form.`;
    case "PARTY_TYPE_REQUIRED":
      return "A company is named as a party of a trust or foundation: state whether it is an operating company, a domiciliary company, a listed company, a trust or a foundation.";
    case "PARTY_OWNERS_REQUIRED":
      return "A domiciliary company is named as a party of a trust or foundation: its beneficial owners must be listed instead.";
    default:
      return `${label}: We could not complete the ownership assessment. Review its ownership and control details before confirming the beneficial owners.`;
  }
}

export default function UboIdentificationNotice({ result, nodes = [] }) {
  const { ownershipLabel } = useOwnershipLabels();
  if (!result?.meta?.reviewRequired) return null;
  const messages = [...new Set((Array.isArray(result.errors) ? result.errors : [])
    .filter(entry => entry?.reviewRequired)
    .map(entry => ownershipLabel(reviewMessage(entry, nodes))))];
  return <div className="alert alert-warning" role="alert">
    <div className="fw-semibold">Beneficial owner identification is incomplete</div>
    {messages.length > 1 ? <ul className="mb-0 mt-2">
      {messages.map(message => <li key={message}>{message}</li>)}
    </ul> : <div className="mt-2">{messages[0] || "Review the ownership and control details before confirming the beneficial owners."}</div>}
  </div>;
}
